export default __webpack_public_path__ + "static/media/plus-18x12-grey.24ec5c14.svg";